import Ebony91 from "../Summarecon Bogor/Tipe 9.webp"
import Ebony92 from "../Summarecon Bogor/Tipe 9.webp"

const Ebony9images =[
    Ebony91,Ebony92
]

export default Ebony9images;